module.exports = __webpack_public_path__ + "static/media/icon-font-bullet-list.27883249.svg";